var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridLarge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4.57143,
    height: 4.57143,
    rx: 1,
    fill: "#585C6C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.71484,
    width: 4.57143,
    height: 4.57143,
    rx: 1,
    fill: "#585C6C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.4277,
    width: 4.57143,
    height: 4.57143,
    rx: 1,
    fill: "#585C6C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 5.71387,
    width: 4.57143,
    height: 4.57143,
    rx: 1,
    fill: "#585C6C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 5.71484,
    y: 5.71387,
    width: 4.57143,
    height: 4.57143,
    rx: 1,
    fill: "#585C6C"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 11.4277,
    y: 5.71387,
    width: 4.57143,
    height: 4.57143,
    rx: 1,
    fill: "#585C6C"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    y: 11.4287,
    width: 4.57143,
    height: 4.57143,
    rx: 1,
    fill: "#585C6C"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 5.71484,
    y: 11.4287,
    width: 4.57143,
    height: 4.57143,
    rx: 1,
    fill: "#585C6C"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 11.4277,
    y: 11.4287,
    width: 4.57143,
    height: 4.57143,
    rx: 1,
    fill: "#585C6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridLarge);
export default __webpack_public_path__ + "static/media/grid-large.68e2a7d0.svg";
export { ForwardRef as ReactComponent };